import 'bootstrap.collapse';
import { registerComponents } from 'component-utils';
import components from 'core-components';
import 'fancybox';
import 'global';
import $ from 'jquery';
import '/assets/theme/js/mmenu-light.js?v=2';

onLoad();

document.addEventListener('DOMContentUpdated', e => onLoad(e.target));

export function onLoad(context = document) {
    // Register the components (if applicable).
    if (context instanceof Document && config.registerComponents !== false)
        registerComponents(components);

    const elementsToFadeInUpOnScroll = context.querySelectorAll('.scroll-reveal');

    if (elementsToFadeInUpOnScroll.length > 0) {
        window.addEventListener('scroll', () => {
            elementsToFadeInUpOnScroll.forEach(element => {
                let positionFromTop = element.getBoundingClientRect().top;

                if (positionFromTop <= window.innerHeight && positionFromTop >= 0)
                    element.classList.add('fade-in-up');
            });
        });
    }

    // Scroll To
    context.querySelectorAll('.scroll-to').forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();

            const href = link.getAttribute('href'); // Use 'link' instead of 'this'.
            const target = context.querySelector(href);

            // Calculate the offsetTop including the offset of all parent elements.
            let offsetTop = target.offsetTop;
            let currentElement = target;

            while (currentElement.offsetParent !== null) {
                currentElement = currentElement.offsetParent;
                offsetTop += currentElement.offsetTop;
            }

            window.scroll({
                top: offsetTop,
                behavior: 'smooth'
            });
        });
    });

    // Show body text mobile read more (Shop only).
    context.querySelectorAll('.read-more-body').forEach(link => {
        link.addEventListener('click', e => {
            e.preventDefault();

            $(e.target).addClass('hide-btn');
            $(e.target).closest('.body-text-wrapper').find('.body-text').addClass('show-body');
        });
    });

    // Scroll to top of page.
    context.querySelectorAll('.scroll-to-top').forEach(link => {
        link.addEventListener('click', e => {
            window.scroll({
                top: 0,
                behavior: 'smooth'
            });
        });
    });

    const menu = new MmenuLight(document.querySelector('#menu-navbar'), '(max-width: 992px)');

    menu.navigation({
        slidingSubmenus: true,
        title: 'Menu'
    });

    const drawer = menu.offcanvas({
        position: 'left'
    });

    // Open the menu.
    document.querySelector('button[href="#menu-navbar"]')
        .addEventListener('click', e => {
            e.preventDefault();
            drawer.open();
        });
}